import { NavigationStates } from 'stores/app-bar-navigation-store';

import CoPilotTabPageController from './co-pilot-tab-page';

const CampaignPageController = () => {
  return <CoPilotTabPageController tab={NavigationStates.TOOL} />;
};

export default CampaignPageController;
